import {REPORT_TYPE} from '../models';

export function typePathMap(type: string | undefined): string {
  switch(type) {
    case REPORT_TYPE.NOTEBOOK:
      return 'n/';
    case REPORT_TYPE.TABLEAU_EMBED:
      return 't/';
    default:
      return '';
  }
}
